import './Bojoko/Polyfills.js';
import {Bootstrap} from './Bojoko/Bootstrap.js';
import './Library/Speed.js';
import './Bojoko/CheckAdBlock.js';

window.bo = new Bootstrap();
window.bo.run();
